import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import ThemeWrapperChat from '@/layouts/ThemeWrapperChat';

const ChatPage = lazy(() => import('@/pages/ChatPage'));
const ChatRedirectedErrorPage = lazy(() => import('@/pages/ChatRedirectedErrorPage'));

// Full-page loading fallback shown while lazy chunks are being fetched.
// Keeps a white screen rather than a blank/broken render.
function PageLoadingFallback() {
  return <div className="fixed inset-0 bg-white" aria-busy="true" />;
}

// Create the router once at module level so that React Router's internal state
// is never discarded on a re-render (which would cause lazy chunks to fail
// mid-load on hard reload or after clearing localStorage).
const router = createBrowserRouter([
  {
    element: <ThemeWrapperChat />,
    children: [
      {
        index: true,
        path: '/:chat_id',
        element: (
          <Suspense fallback={<PageLoadingFallback />}>
            <ChatPage />
          </Suspense>
        ),
      },
      // catch errors
      {
        path: '*',
        element: (
          <Suspense fallback={<PageLoadingFallback />}>
            <ChatRedirectedErrorPage />
          </Suspense>
        ),
      },
    ],
  },
]);

export default router;
